import {GETPAYSTUBS, GETPAYSTUBSERR} from '../../actions/reviewer_actions/paystubsActions';


var initialState = {
  paystubs: [],
  loading:'asdf'
};

export default function(state = initialState, action) {

  switch (action.type) {
    case GETPAYSTUBS:{
      let payStubArry = action.payload;
      payStubArry.sort(function(a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.createdAt) - new Date(a.createdAt);
      });  


      return {
         ...state,
         paystubs:payStubArry,
         loading:new Date()
          };
      }

    case GETPAYSTUBSERR:{
      return {
         ...state,
         loading:new Date(),
           };
      }

   
    default:
      return state;
  }
}
